
import { CarregaService } from '../services/carrega_file/carrega.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { format, parse, differenceInDays } from 'date-fns';
import { ApiService } from '../services/contratos/contratos.service';
import { map, take } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { utcParse } from 'd3';
import { Location } from '../../app/interfaces';
import { now } from 'lodash';

@Component({
    selector: 'app-upload-excel-container',
    templateUrl: './upload-excel-container.component.html',
    styleUrls: ['./upload-excel-container.component.css'],
    standalone: false
})
export class UploadExcelContainerComponent {

  progressValue = 0; // Valor atual da barra de progresso
  maxValue = 0; // Valor máximo da barra de progresso
  showProgressBar = false;
  @ViewChild('downloadLink') downloadLink!: ElementRef<HTMLAnchorElement>;
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  query: string = 'items_Excel_Container';
  tableNameLocation: string = 'Fornecedores_Karrara_Transport';
  query2: string = 'veiculos_lab_Karrara'
  items$: Observable<any> | undefined;
  dataLoaded = false;
  jsonData: any;
  sortColumn: string = '';
  sortDirection: number = 1;
  dias_terminal: Date = new Date();
  Freetime: number = 0;
  dados: any[] = [];
  contratos: string[] = [];
  freetime: string[] = [];
  tripcost: string[] = [];
  custoViagem: string = "";
  handling: string[] = [];
  manuseio: string = "";
  demurrage: string[] = [];
  estadia: string = "";
  valorFree: string = '';
  liner: string = "";
  vessel: string = "";
  custoestadia: number = 0;
  isLoading: boolean = true;
  query3: string = 'tipos_Veiculos_Karrara';
  urlConsultaCompleta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  veiculos!: any[];
  veiculosLab!: any[];
  locais!: any[];
  items!: any[]
  referenceDate!: string;
  faturas!: any[];
  mensagemAviso: string | null = null;

  constructor(
    private carregaService: CarregaService,
    private http: HttpClient,
    private dynamodbService: ApiService
  ) { }

  async onFileSelected(event: any) {
    // debugger
    this.isLoading = true;
    const file: File = event.target.files[0];
    const fileUrl = URL.createObjectURL(file);
    const fileBlob = await fetch(fileUrl).then(response => response.blob());
    const rawData = await this.carregaService.loadFile(fileBlob);
    // console.log(rawData)
    const inflatedData = await this.inflateData(rawData); // Inflar os campos desejados
    this.jsonData = await this.calcularDistancia(inflatedData);
    // this.jsonData = await this.calculoConsumo(inflatedData);
    // this.jsonData = await this.relacionarFaturasContainer(inflatedData);
    this.dataLoaded = true;
    this.isLoading = false;
    // console.log(this.jsonData)
  }

  async salvarNoBanco(jsonData: any) {
    this.isLoading = true;
    this.showProgressBar = true;
    // console.log('Item a ser salvo:', jsonData);
    this.progressValue = 0;
    this.maxValue = jsonData.length;
    const batchSize = 10; // Defina o tamanho máximo para cada lote
    const batches = this.chunkArray(jsonData, batchSize); // Fraciona o jsonData em lotes menores
    for (const batch of batches) {
      // Acrescentar o campo "lastupdate" com o valor da data de hoje
      const currentDate = new Date().getTime();
      for (const item of batch) {
        item.created = currentDate.toString();
      }
      await this.dynamodbService.salvar(batch, this.query, this.urlAtualiza).subscribe(
        response => {
          this.progressValue = this.progressValue + batch.length;
          // //console.log('Resposta do salvamento:', response);
          this.showProgressBar = false;
          this.isLoading = false;
          this.jsonData = null;
          // window.alert("Viagens inseridas com sucesso!");
          this.mostrarAviso();
        },
        error => {
          console.error('Erro ao salvar:', error);
        }
      );
    }
  }

mostrarAviso() {
  this.mensagemAviso = "Viagens inseridas com sucesso!";
  // Esconde o alerta após 3 segundos
  setTimeout(() => {
    this.mensagemAviso = null;
  }, 3000);
}

  chunkArray(array: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  async ngOnInit() {
    await this.getLocais();
    // await this.getItemsFaturaContainer();
    await this.getVeiculosFromDynamoDB();
    await this.getVeiculosLab();
    const key = 'liner'; // Substitua 'propriedade' pelo nome da propriedade que você deseja obter
    const query = 'PowerMathDatabase2'
    const filtro = '';
    this.items$ = (await this.dynamodbService.getItems(query, this.urlConsulta, filtro)).pipe(
      map(data => {
        const parsedData = JSON.parse(data.body); // Parse a string JSON contida em data.body
        return parsedData; // Retorna o objeto JSON parseado
      })
    );
    this.items$.subscribe(
      items => {
        this.contratos = items.map((item: { liner: any; }) => item.liner);
        this.freetime = items.map((item: { freetime: any; }) => item.freetime);
        this.tripcost = items.map((item: { tripcost: any; }) => item.tripcost);
        this.handling = items.map((item: { fsperiod: any; }) => item.fsperiod);
        this.demurrage = items.map((item: { scperiod: any; }) => item.scperiod);
      },
      error => {
        console.error(error);
      }
    );
    this.isLoading = false;
  }

  testarArquivo(arquivo: File): void {
    this.carregaService.testarArquivoCSV(arquivo).then((estaCorreto) => {
      if (estaCorreto) {
        //console.log('O arquivo CSV está correto.');
      } else {
        //console.log('O arquivo CSV está incorreto.');
      }
    }).catch((erro) => {
      console.error('Erro ao testar o arquivo CSV:', erro);
    });
  }

  converterNumeroSerieParaData(numeroSerie: number): Date {
    // Data de referência do Excel (31 de dezembro de 1899)
    const excelStartDate: Date = new Date('1899-12-31');
    // Calcula a data adicionando o número de dias ao início do calendário do Excel
    const convertedDate: Date = new Date(excelStartDate.getTime() + (numeroSerie * 24 * 60 * 60 * 1000));
    // Cria uma nova data apenas com o ano, mês e dia da data original
    const extractedDate: Date = new Date(convertedDate.getFullYear(), convertedDate.getMonth(), convertedDate.getDate());
    // console.log(extractedDate);
    // console.log(convertedDate);
    return extractedDate;
  }

  // Função para converter fração do dia em formato de hora
  converterHora(fraçãoDoDia: number, data: Date): Date {
    const horas: number = Math.floor(fraçãoDoDia * 24); // Extrai as horas
    const minutos: number = Math.round(((fraçãoDoDia * 24) % 1) * 60); // Extrai os minutos
    // Formata a hora e o minuto para que tenham sempre dois dígitos
    const horaFormatada: string = ('0' + horas).slice(-2);
    const minutosFormatados: string = ('0' + minutos).slice(-2);
    // Retorna a hora formatada
    const horaString = horaFormatada + ":" + minutosFormatados;
    // Divide a string da hora em horas e minutos
    const [hora, minuto] = horaString.split(':').map(Number);
    // Define as horas e minutos na data obtida anteriormente
    data.setHours(hora - 3, minuto, 0, 0);
    // console.log(data);
    return data
  }

  inflateData(rawData: any[]): any[] {
    // debugger
    this.isLoading = true;
    let dataMap: { [key: string]: any } = {};
    rawData.forEach((item: any) => {
      let idContainer = item[4]; // ID CONTAINER   
      const dataFormatada: Date = this.converterNumeroSerieParaData(item[1]);
      const horaFormatada: Date = this.converterHora(item[2], dataFormatada);
      let dataFaltaFormatadaStr = '';
      let part = "";
      let quantidadeParts = 0;
      let quantidadeMU = 0;
      // Determinar a data de falta formatada
      try{
      if (!item[7].includes("PNEUS")) {
        if (item[14] !== undefined) {
          const dataFaltaFormatada: Date = this.converterNumeroSerieParaData(item[14]);
          dataFaltaFormatadaStr = dataFaltaFormatada.toDateString();
        }
        part = ""; // Part (coluna 6)
        quantidadeParts = item[9];
        quantidadeMU = item[9];
      } else {
        if (item[16] !== undefined) {
          const dataFaltaFormatada: Date = this.converterNumeroSerieParaData(item[16]);
          dataFaltaFormatadaStr = dataFaltaFormatada.toDateString();
        }
        part = item[9]; // Part (coluna 6)
        quantidadeParts = item[11];
        quantidadeMU = item[12];
      }
    }catch{
      console.log(item[7])
    }
      // Checa se o ID CONTAINER já existe no mapa de dados
      if (dataMap[idContainer]) {
        // console.log(dataMap[idContainer])
        // Concatenando os itens da coluna 6 (Part)
        dataMap[idContainer].part += `, ${part}`;
        // Somando os valores da coluna 11 (quantidadeParts)
        dataMap[idContainer].quantidadeParts += quantidadeParts;
        dataMap[idContainer].quantidadeMU += quantidadeMU;
        dataMap[idContainer].Volumes += quantidadeMU;
        // console.log(quantidadeMU)
        // console.log(quantidadeParts)
      } else {
        // Inicializando os dados se o ID não estiver no mapa
        let inflatedItem: any = {
          'tableName': this.query,
          'ID': item[4],
          'Plate': "",
          'idContainer': item[4],
          'transportador': item[0],
          'Janela': horaFormatada,
          'dataJanelaTimeTable': horaFormatada.toISOString().slice(0, 10),
          'horaJanelaTimeTable': horaFormatada.toISOString().slice(11, 16),
          'processo': item[3],
          'linner': item[5],
          'fatura': item[6],
          'destino': item[7],
          'num_NF1': item[8],
          'date': new Date(),
          'Weight Loaded': 18400
        };
        try{
        if (!item[7].includes("PNEUS")) {
          inflatedItem = {
            ...inflatedItem,
            'quantidadeMU': quantidadeMU,
            'Volumes': quantidadeMU,
            'terminalOrigem': item[10],
            'Fornecedor 1': item[10],
            'destinoApos': item[11],
            'terminalAtual': item[12],
            'itemCritico': item[13],
            'invoiceRemarks': item[15],
            'CTNRAlugado': item[16]
          };
        } else {
          console.log("entrou no else")
          inflatedItem = {
            ...inflatedItem,
            'part': part,
            'description': item[10],
            'quantidadeParts': quantidadeParts,
            'quantidadeMU': quantidadeMU,
            'Volumes': quantidadeMU,
            'terminalOrigem': item[13],
            'Fornecedor 1': item[13],
            'destinoApos': item[14],
            'terminalAtual': item[15],
            'CTNRAlugado': item[17],
            'dataFalta': dataFaltaFormatadaStr           
          }
        }
      }catch{
        console.log(item)
      }
        dataMap[idContainer] = inflatedItem;
      }
    });
    // Convertendo o mapa de dados de volta para um array
    return Object.values(dataMap);
  }


  async getVeiculosFromDynamoDB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query3, this.urlConsultaCompleta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculos = items.map(item => ({ ...item, checked: false }));
            // this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  sortBy(column: string) {
    if (this.sortColumn === column) {
      // Reverse the sort direction
      this.sortDirection *= -1;
    } else {
      // Set the new sort column and reset the sort direction
      this.sortColumn = column;
      this.sortDirection = 1;
    }
    // Sort the data array based on the selected column and direction
    this.jsonData.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[this.sortColumn];
      const valueB = b[this.sortColumn];

      if (valueA < valueB) {
        return -1 * this.sortDirection;
      } else if (valueA > valueB) {
        return 1 * this.sortDirection;
      } else {
        return 0;
      }
    });
  }

  async getVeiculosLab(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query2, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculosLab = items
              .map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            // Filtra os itens com chave 'DataBordo' indefinida
            // console.log(this.veiculosLab)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getLocais(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.tableNameLocation, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.locais = items;
              // console.log(this.locais)
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  findLocationByName(name: string, locations: any[]): Location {
    // debugger
    if (name == "LCB") {
      name = "LCB DEMARCHI"
    }
    return locations['find']((location: { local: string; }) => location.local === name);
  }

  convertItem(item: any): any {
    return {
      ID: item.ID,
      latitude: parseFloat(item.latitude),  // Convertendo latitude para número
      local: item.local,
      longitude: parseFloat(item.longitude),  // Convertendo longitude para número
      tableName: item.tableName
    };
  }

  async calcularRota(startLocation: number[], endLocation: number[]): Promise<[number, number]> {
    try {
      const response: any = await (await this.dynamodbService.getRota("https://klyufov1p0.execute-api.sa-east-1.amazonaws.com/v1/POST", startLocation, endLocation)).toPromise();
      if (response.statusCode === 200) {
        const data = response.body;
        if (data) {
          const distance = data.Distance;
          const durationSeconds = data.DurationSeconds;
          return [distance, durationSeconds];
        } else {
          console.error('Data not found in the response:', data);
          return [0, 0];
        }
      } else {
        console.error('Invalid response:', response);
        return [0, 0];
      }
    } catch (error) {
      console.error('Error processing data:', error);
      return [0, 0];
    }
  }

  sumArrays(array1: number[], array2: number[]): number[] {
    if (array1.length !== array2.length) {
      throw new Error('Arrays must have the same length');
    }
    return array1.map((value, index) => value + array2[index]);
  }

  async calcularDistancia(items: any[]): Promise<any> {
    for (const container of items) {
      let atualLocation = { local: "", latitude: 0, longitude: 0 };
      let distance1 = [0, 0];
      let distance2 = [0, 0];
      let distanceTotal = [0, 0];
      const origemLocation = this.findLocationByName(container.terminalOrigem, this.locais);
      atualLocation = await this.findLocationByName(container.terminalAtual, this.locais);
      const destinoLocation = await this.findLocationByName(container.destino, this.locais);
      if (origemLocation && atualLocation) {
        const origemLocationNumber = this.convertItem(origemLocation);
        var atualLocationNumber = this.convertItem(atualLocation);
        distance1 = await this.calcularRota([origemLocationNumber.longitude, origemLocationNumber.latitude], [atualLocationNumber.longitude, atualLocationNumber.latitude]);
        container.distanceTrecho1 = distance1[0];
      }
      if (destinoLocation && atualLocation) {
        const destinoLocationNumber = this.convertItem(destinoLocation);
        var atualLocationNumber = this.convertItem(atualLocation);
        distance2 = await this.calcularRota([destinoLocationNumber.longitude, destinoLocationNumber.latitude], [atualLocationNumber.longitude, atualLocationNumber.latitude]);
        container.distanceTrecho2 = distance2[0];
      }
      if (!atualLocation && origemLocation && destinoLocation) {
        const origemLocationNumber = this.convertItem(origemLocation);
        const destinoLocationNumber = this.convertItem(destinoLocation);
        distance2 = await this.calcularRota([destinoLocationNumber.longitude, destinoLocationNumber.latitude], [origemLocationNumber.longitude, origemLocationNumber.latitude]);
        container.distanceTrecho2 = distance2[0];
      }
      // console.log(container.idContainer)
      // console.log(container.distanceTrecho1)
      // console.log(container.distanceTrecho2)
      container['Transport Type'] = this.veiculosLab.find((veiculo: { placa: any; }) => veiculo.placa == container.Plate)
        ? this.veiculosLab.find((veiculo: { placa: any; }) => veiculo.placa == container.Plate).modelo
        : "R450 LA4x2MNA";
      container.emissao = this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type'])
        ? this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type']).emissoes
        : 0;
      container.consumo = this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type'])
        ? this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type']).consumo
        : 0;
      container.emissaoTrecho1 = (container.distanceTrecho1 * container.emissao) / container.consumo;
      container.emissaoTrecho2 = (container.distanceTrecho2 * container.emissao) / container.consumo;

      container['Total Distance'] = (container.distanceTrecho1 ? container.distanceTrecho1 : 0) + (container.distanceTrecho2 ? container.distanceTrecho2 : 0);
      container['emissaoTotal'] = (container.emissaoTrecho1 ? container.emissaoTrecho1 : 0) + (container.emissaoTrecho2 ? container.emissaoTrecho2 : 0);
      // console.log(container['Total Distance'])
    }
    // console.log(items)
    return items;
  }

}
